module.exports = __webpack_public_path__ + "static/media/cd.25868a96.svg";